import { render, staticRenderFns } from "./ProgramSekolahHebat.vue?vue&type=template&id=77a48670&"
import script from "./ProgramSekolahHebat.vue?vue&type=script&lang=js&"
export * from "./ProgramSekolahHebat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports